import { FC, FocusEventHandler } from 'react';
import NumberFormat from 'react-number-format';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextInputBase from './TextInputBase'
import { useContextField } from '../../../api';
import { ErrorMessage, FormLabel } from '../helpers';

const CurrencyInput: FC<any> = ({ inputRef, ...rest }: any) => <NumberFormat {...rest} getInputRef={inputRef} thousandSeparator isNumericString allowNegative={false} />

export default (props: {
    label: string;
    name: string;
    disabled?: boolean;
    className?: string;
    onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}) => {
    const [field, _, helper] = props.name ? useContextField<string | undefined>(props.name) : [];
    const { label, onBlur, ...rest } = props;
    return <>
        <FormLabel label={label} />
        <TextInputBase
            {...rest}
            {...field}
            variant="outlined"
            InputProps={{ inputComponent: CurrencyInput, startAdornment: <InputAdornment position="start" disablePointerEvents>$</InputAdornment>, onBlur }}
            onChange={e => !!helper && helper.setValue(e.target.value.indexOf(',') !== -1 ? e.target.value.split(',').join('') : e.target.value)}
        />
        {!!field && <ErrorMessage name={field.name} />}
    </>
}
